<template lang="pug">
textbox-base.textbox-setting(v-model='inputValue', :placeholder='placeholder')
  slot
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TextboxBase from '@/components/atoms/TextboxBase.vue'

/**
 * 設定用テキストボックス
 */
@Component({
  components: {
    TextboxBase,
  },
})
export default class TextboxSetting extends Vue {
  // 入力値
  @Prop()
  value!: string

  // プレースホルダー（任意）
  @Prop()
  placeholder?: string

  // 入力値ゲッター・セッター
  get inputValue(): string {
    return this.value
  }
  set inputValue(value: string) {
    this.$emit('input', value)
  }
}
</script>

<style lang="stylus" scoped>
.textbox-setting
  width 510px
  height 42px
  padding 13px 16px
  border-radius 10px
  background-color var(--color-input-manager-setting-textbox__background)
  border 1px solid var(--color-input-manager-setting-textbox__border)
  transition-property boader background-color
  transition-timing-function ease-out
  transition-duration 300ms

  &:hover, &:focus
    border-color var(--color-input-manager-setting-textbox__border-hover)
    background-color transparent

  &:disabled
    background-color var(--color-input-manager-setting-textbox__background-disabled)
    border-color var(--color-input-manager-setting-textbox__border-disabled)
    cursor default
</style>
